import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, money } from "@/lib/api";
import { StatCard, Button, Badge, Empty } from "@/lib/ui";

export default function ReferorDashboard() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/referor/dashboard").then(({ data }) => setD(data)); }, []);
  if (!d) return <p className="text-slate-400">Loading…</p>;
  const { summary: s, referrals } = d;
  return (
    <div>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="font-head text-2xl font-extrabold text-slate-900">Welcome, {d.referor.name}</h1>
          <p className="mt-1 text-sm text-slate-500">Referor ID <b>{d.referor.code}</b> · You earn 10% of the pre-tax package amount on every business you refer.</p>
        </div>
        <Button onClick={() => nav("/referor/app/refer")} data-testid="dash-refer-btn"><i className="fa-solid fa-plus" /> Refer a Business</Button>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-5">
        <StatCard testid="ref-stat-earned" label="Total Earned" value={money(s.earned)} icon="fa-coins" tone="green" />
        <StatCard testid="ref-stat-paid" label="Received" value={money(s.paid)} icon="fa-money-bill-wave" tone="blue" />
        <StatCard testid="ref-stat-balance" label="Outstanding" value={money(s.balance)} icon="fa-wallet" tone="orange" />
        <StatCard testid="ref-stat-referrals" label="Referrals" value={referrals.length} icon="fa-handshake" />
        <StatCard testid="ref-stat-converted" label="Converted" value={d.converted} icon="fa-circle-check" tone="green" />
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-3 rounded-2xl border border-orange-200 bg-orange-50 p-4 text-sm" data-testid="payment-schedule-card">
        <i className="fa-solid fa-calendar-check text-orange-600" />
        <span>Payouts are made by Deadstock.live on the <b>25th of every month</b>. Next scheduled date: <b>{new Date(d.next_payment_date).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</b>.</span>
        <button onClick={() => nav("/referor/app/earnings")} className="ml-auto text-xs font-semibold text-orange-700 underline">View payment history</button>
      </div>
      <h2 className="mt-8 font-head text-lg font-bold text-slate-900">My Referrals</h2>
      {referrals.length === 0 ? <Empty text="No referrals yet — refer your first business" icon="fa-handshake" /> : (
        <div className="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-white">
          <table className="w-full text-left text-sm">
            <thead><tr className="text-xs uppercase text-slate-400"><th className="px-4 py-2">Business</th><th className="px-4 py-2">Contact</th><th className="px-4 py-2">Category</th><th className="px-4 py-2">Status</th><th className="px-4 py-2">Referred</th></tr></thead>
            <tbody>{referrals.map((r) => (
              <tr key={r.id} className="border-t border-slate-100" data-testid={`referral-row-${r.id}`}>
                <td className="px-4 py-2 font-semibold text-slate-800">{r.company}</td>
                <td className="px-4 py-2">{r.name}<br /><span className="text-xs text-slate-500">+91 {r.phone}</span></td>
                <td className="px-4 py-2">{r.category}</td>
                <td className="px-4 py-2"><Badge tone={r.status === "converted" ? "emeraldSoft" : "slate"}>{r.status}</Badge></td>
                <td className="px-4 py-2 text-xs text-slate-500">{new Date(r.created_at).toLocaleDateString()}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
